import React, { useState } from 'react';
import Icon from 'components/AppIcon';

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, goal }) {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm(goal);
      onClose();
    } finally {
      setDeleting(false);
    }
  };

  if (!isOpen || !goal) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-[#0F172A] border border-[rgba(239,68,68,0.2)] rounded-2xl shadow-2xl p-6">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-[rgba(239,68,68,0.1)] flex items-center justify-center mb-4">
            <Icon name="Trash2" size={22} color="#EF4444" />
          </div>
          <h3 className="font-heading font-bold text-base text-[#F8FAFC] mb-2">Delete Goal</h3>
          <p className="text-sm text-[#94A3B8] mb-1">Are you sure you want to delete</p>
          <p className="text-sm font-semibold text-[#F8FAFC] mb-4">"{goal?.title}"?</p>
          <p className="text-xs text-[#64748B] mb-6">This action cannot be undone. All progress data will be permanently removed.</p>
          <div className="flex gap-3 w-full">
            <button
              onClick={onClose}
              className="flex-1 py-2.5 rounded-lg border border-[rgba(6,182,212,0.2)] text-sm text-[#94A3B8] hover:bg-[rgba(6,182,212,0.05)] transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={deleting}
              className="flex-1 py-2.5 rounded-lg bg-[rgba(239,68,68,0.15)] border border-[rgba(239,68,68,0.3)] text-sm font-semibold text-[#EF4444] hover:bg-[rgba(239,68,68,0.25)] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {deleting ? <div className="w-4 h-4 border-2 border-[#EF4444] border-t-transparent rounded-full animate-spin" /> : null}
              Delete Goal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
